import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
export var SimpleHeroUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SimpleHeroUnwrapped, _PureComponent);

  function SimpleHeroUnwrapped() {
    _classCallCheck(this, SimpleHeroUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleHeroUnwrapped).apply(this, arguments));
  }

  _createClass(SimpleHeroUnwrapped, [{
    key: "onDwell",
    value: function onDwell() {
      var onView = this.props.onView;

      if (onView) {
        onView();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          backgroundColor = _this$props.backgroundColor,
          body = _this$props.body,
          children = _this$props.children,
          cta = _this$props.cta,
          footer = _this$props.footer,
          _this$props$imageAlig = _this$props.imageAlignment,
          imageAlignment = _this$props$imageAlig === void 0 ? 'left' : _this$props$imageAlig,
          imageAlt = _this$props.imageAlt,
          imageUrl = _this$props.imageUrl,
          title = _this$props.title,
          titleSize = _this$props.titleSize;
      return React.createElement("div", {
        className: classNames((_classNames = {
          'simple-hero': true
        }, _defineProperty(_classNames, "simple-hero--".concat(imageAlignment), true), _defineProperty(_classNames, 'simple-hero--no-image', !imageUrl), _defineProperty(_classNames, "bg--".concat(backgroundColor), true), _classNames))
      }, React.createElement("section", null, React.createElement("div", {
        className: "simple-hero__content"
      }, title && React.createElement("h2", {
        className: "text--".concat(titleSize || 'xl')
      }, title), body && React.createElement("p", {
        className: "simple-hero__body"
      }, body), cta), imageUrl && React.createElement("div", {
        className: "simple-hero__image"
      }, React.createElement("img", {
        src: imageUrl,
        alt: imageAlt
      }))), children, footer && React.createElement("p", {
        className: "simple-hero__footer"
      }, footer));
    }
  }]);

  return SimpleHeroUnwrapped;
}(PureComponent);
SimpleHeroUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['light', 'white']),
  body: PropTypes.node,
  children: PropTypes.node,
  cta: PropTypes.node,
  footer: PropTypes.node,
  imageAlignment: PropTypes.oneOf(['left', 'right']),
  imageAlt: PropTypes.string,
  imageUrl: PropTypes.string,
  onView: PropTypes.func,
  title: PropTypes.node,
  titleSize: PropTypes.string
};
export var SimpleHero = trackDwell(SimpleHeroUnwrapped);